import styled from "styled-components";
import { colors } from "../../../../../styles/colors";

export const ConversionRateContainer = styled.div`
  margin-top: auto;
  position: absolute;
  bottom: 18px;
  left: 12px;
  right: 20px;
  text-align: center;

  .conversion-rate-title {
    font-size: 14px;
    color: ${colors.darkBlue};
    margin-bottom: 8px;
  }
  .conversion-rate-value {
    width: 107px;
    background-color: ${colors.lightBlueGrayAlpha};
    border-radius: 9px;
    padding: 2px 0;
    font-size: 14px;
    color: ${colors.blueGray};
    margin: 0 auto;
  }
`;
